export const generatedFeasibilityReport = {
  "schemaVersion": 1,
  "title": "Interplanetary Industrial Feasibility Report",
  "mode": "decision-support-report-not-operational-mission-design",
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "build": {
    "id": "ui-fidelity-2026-06-19T05-20Z",
    "label": "UI fidelity build 2026-06-19 05:20 UTC"
  },
  "inputs": {
    "scenarioSet": "Primary set (6)",
    "horizonYears": 18,
    "capitalUsdBn": 280,
    "launchMassT": 160
  },
  "executiveSummary": {
    "selectedScenarioId": "hybrid",
    "selectedScenarioName": "Hybrid Moon -> Asteroid -> Mercury",
    "deterministicUtility": 65.69,
    "medianUtility": 65.65,
    "utilityRangeP10P90": [
      63.33,
      67.88
    ],
    "winProbabilityPercent": 25,
    "businessReadiness": 72.6,
    "totalProgramNeedBn": 61.13,
    "capitalGapBn": 0,
    "fundingCoveragePercent": 100,
    "recommendationCaveat": "Planner outputs are heuristics until dated cost sources, runtime trajectory artifacts, and source-backed feedstock evidence are attached."
  },
  "scenarioComparison": [
    {
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "summary": "Fastest learning loop and lowest communications burden.",
      "utility": 67.12,
      "benefitScore": 66.95,
      "riskScore": 33.91,
      "uncertaintyPenalty": 8,
      "medianUtility": 67,
      "winProbabilityPercent": 75,
      "businessReadiness": 76.3,
      "totalProgramNeedBn": 49.19,
      "capitalGapBn": 0
    },
    {
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "summary": "Bootstrap close, screen feedstock, then scale toward Mercury energy advantage.",
      "utility": 65.69,
      "benefitScore": 80.53,
      "riskScore": 47.09,
      "uncertaintyPenalty": 12,
      "medianUtility": 65.65,
      "winProbabilityPercent": 25,
      "businessReadiness": 72.6,
      "totalProgramNeedBn": 61.13,
      "capitalGapBn": 0
    },
    {
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "summary": "Potential materials bank, but composition and operations are object-specific.",
      "utility": 51.37,
      "benefitScore": 69.21,
      "riskScore": 54.8,
      "uncertaintyPenalty": 18,
      "medianUtility": 51.57,
      "winProbabilityPercent": 0,
      "businessReadiness": 60.2,
      "totalProgramNeedBn": 69.7,
      "capitalGapBn": 0
    },
    {
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "summary": "Maximum long-term energy/vacuum upside, high logistics and autonomy burden.",
      "utility": 42.95,
      "benefitScore": 80.84,
      "riskScore": 75.96,
      "uncertaintyPenalty": 24,
      "medianUtility": 42.95,
      "winProbabilityPercent": 0,
      "businessReadiness": 55.8,
      "totalProgramNeedBn": 97.12,
      "capitalGapBn": 0
    },
    {
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "summary": "Strong exploration ecosystem, weak for first industrial-capacity maximization.",
      "utility": 40.78,
      "benefitScore": 48.11,
      "riskScore": 54.84,
      "uncertaintyPenalty": 12,
      "medianUtility": 40.66,
      "winProbabilityPercent": 0,
      "businessReadiness": 63.1,
      "totalProgramNeedBn": 67.75,
      "capitalGapBn": 0
    },
    {
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "summary": "Polar volatile access is attractive, but surface thermal/comms risk is severe.",
      "utility": 37.95,
      "benefitScore": 76.32,
      "riskScore": 78.13,
      "uncertaintyPenalty": 26,
      "medianUtility": 37.78,
      "winProbabilityPercent": 0,
      "businessReadiness": 55,
      "totalProgramNeedBn": 103.67,
      "capitalGapBn": 0
    }
  ],
  "paretoFrontier": [
    {
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "utility": 67.12,
      "uncertaintyPenalty": 8
    }
  ],
  "decisionMemo": {
    "mode": "business-feasibility-decision-memo",
    "customerUseState": "blocked-until-source-use-review",
    "sellableBetaLane": "paid-beta-internal-diligence-with-citation-review",
    "selectedScenarioId": "hybrid",
    "selectedScenarioName": "Hybrid Moon -> Asteroid -> Mercury",
    "topDecisionScenarioId": "moon-first",
    "topDecisionLane": "lane-2-conditional-diligence",
    "selectedDecisionLane": "lane-3-watchlist",
    "selectedDecisionReadinessScore": 59.78,
    "commercializationAllowed": false,
    "confidenceBand": "research-backlog-confidence",
    "investmentQuestion": "Which off-world industrial scenario deserves the next paid diligence sprint, what assumptions drive that answer, and what evidence would change it?",
    "currentAnswer": "Use the current ranking as decision support only; it is not a mission design, verified resource claim, or cleared customer report until the listed gates close.",
    "buyerFacingValue": "Converts public science, engineering, economics, and source-rights evidence into reproducible scenario comparisons with explicit uncertainty and blockers.",
    "proofToChangeAnswer": [
      {
        "lane": "scenario-crossover",
        "requiredChange": 1.43,
        "challengerScenarioId": "hybrid",
        "state": "mathematically-reachable-not-validated"
      },
      {
        "lane": "decision-audit",
        "scenarioId": "hybrid",
        "proofBurden": {
          "blockerCount": 20,
          "criticalNextProofs": [
            "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
            "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
            "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
            "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "Asteroid/resource candidates are not promoted for resource claims.",
            "Claim claim-helium3: blocked-for-commercial-proof"
          ],
          "sourcePromotionState": "source-promotion-ready-for-review",
          "sidecarPromotionState": "partial-runtime-promotion-contract-gaps",
          "modelValidationCommercialUseAllowed": false
        },
        "flipCondition": {
          "kind": "challenger-crossover-threshold",
          "comparisonScenarioId": "moon-first",
          "comparisonScenarioName": "Moon-first Bootstrap",
          "utilityGap": 1.43,
          "condition": "This scenario becomes the deterministic leader only if its benefits improve or risks fall by more than the gap to the current leader.",
          "requiredDelta": 1.43
        }
      }
    ],
    "topBlockers": [
      "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
      "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
      "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
      "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
      "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
      "Customer-facing report use is blocked until source-use review packets are approved.",
      "5 science sidecar validation artifact(s) remain blocked."
    ],
    "nextProofActions": [
      {
        "id": "source-use-review-nasa-clps",
        "lane": "source-use",
        "title": "Commercial Lunar Payload Services",
        "state": "blocked-customer-use-review",
        "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables."
      },
      {
        "id": "source-use-review-spacex-rideshare",
        "lane": "source-use",
        "title": "SpaceX Rideshare Program",
        "state": "blocked-customer-use-review",
        "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables."
      },
      {
        "id": "work-order-spice-gf-event-window-v1",
        "lane": "runtime-sidecar",
        "title": "NASA NAIF SPICE Geometry Finder spice-gf-event-window-v1",
        "state": "blocked-worker-not-installed",
        "nextAction": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json"
      },
      {
        "id": "work-order-orekit-propagation-v1",
        "lane": "runtime-sidecar",
        "title": "Orekit orekit-propagation-v1",
        "state": "blocked-worker-not-installed",
        "nextAction": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json"
      },
      {
        "id": "launch-list-price-source",
        "lane": "economics-source",
        "title": "Launch list-price source intake",
        "state": "blocked-for-commercial-economics",
        "nextAction": "Source data is not normalized into model-ready numeric inputs."
      }
    ],
    "evidenceHashes": {
      "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
      "customerDecisionDossierLedger": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
      "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
      "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
      "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
      "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
      "economicsEvidenceLedger": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
      "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
      "sourceUseReviewPacket": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
      "sourceUseClearanceDossier": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
      "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
      "sidecarWorkOrderPacket": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
      "trajectoryResidualAcceptanceLedger": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
      "trajectoryResidualEvidenceLedger": "sha256-eff8e56cec9a8a20a9ed2b19825f3d35f7d3b019262cf01b8ba64f15e1cf9785",
      "candidateSourceClosurePackets": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
      "candidateSourcePromotionLedger": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a"
    },
    "memoHash": "fnv1a32-3b491547"
  },
  "evidence": {
    "sourceRegistryHash": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "asteroidCandidateEvidenceLedgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
    "candidateSourceClosurePacketHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
    "candidateSourcePromotionLedgerHash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
    "claimEvidenceLedgerHash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
    "modelArtifactBundleHash": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "materialsProcessEvidenceLedgerHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
    "spaceEnvironmentEvidenceLedgerHash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
    "modelValidationProtocolLedgerHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
    "modelRunLedgerHash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "modelRunComparisonLedgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
    "economicsFrontierHash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "economicsEvidenceLedgerHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
    "assumptionImpactLedgerHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
    "capabilityMaturityLedgerHash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
    "customerDecisionDossierLedgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
    "scenarioDecisionLedgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
    "scenarioCrossoverFrontierHash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
    "scenarioUncertaintyBudgetLedgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
    "scenarioDecisionAuditLedgerHash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
    "trajectoryResidualAcceptanceLedgerHash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
    "trajectoryResidualEvidenceLedgerHash": "sha256-eff8e56cec9a8a20a9ed2b19825f3d35f7d3b019262cf01b8ba64f15e1cf9785",
    "economicsFrontier": {
      "mode": "deterministic-seeded-economics-frontier",
      "artifactId": "artifact-economics-uncertainty-v1",
      "claimState": "model-derived-unvalidated",
      "iterations": 512,
      "seed": "economics-frontier-v1-2026-06-19",
      "reportHash": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
      "mostLikelyBusinessWinner": "moon-first",
      "promotionAllowed": false,
      "blockerCount": 3
    },
    "workspaceLedgerHash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
    "modelRuns": {
      "mode": "deterministic-versioned-model-run-ledger",
      "runCount": 3,
      "ledgerHash": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
      "selectedRun": {
        "id": "run-hybrid-base-2026-06-19",
        "label": "Hybrid base feasibility run",
        "purpose": "Canonical beta decision-support run used for the generated feasibility report.",
        "generatedAt": "2026-06-19T00:00:00.000Z",
        "claimState": "model-derived-unvalidated",
        "selectedScenario": {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "utility": 65.69,
          "benefitScore": 80.53,
          "riskScore": 47.09,
          "uncertaintyPenalty": 12,
          "rank": 2
        },
        "inputs": {
          "scenarioSet": "Primary set (6)",
          "horizonYears": 18,
          "capitalUsdBn": 280,
          "launchMassT": 160
        },
        "weights": {
          "benefits": {
            "energy": 1,
            "vacuum": 0.75,
            "optionality": 1,
            "processFit": 1,
            "resourceConfidence": 1
          },
          "risks": {
            "transport": 1,
            "thermal": 0.9,
            "comms": 0.8,
            "feedstock": 1,
            "processMaturity": 0.8
          }
        },
        "uncertainty": {
          "iterations": 256,
          "seed": "run-hybrid-base-2026-06-19",
          "selectedMedianUtility": 65.77,
          "selectedP10P90": [
            63.67,
            67.91
          ],
          "selectedWinProbabilityPercent": 26.95
        },
        "businessCase": {
          "businessReadiness": 72.6,
          "totalProgramNeedBn": 61.13,
          "capitalGapBn": 0,
          "fundingCoveragePercent": 100
        },
        "scenarioRanking": [
          {
            "rank": 1,
            "scenarioId": "moon-first",
            "name": "Moon-first Bootstrap",
            "utility": 67.12,
            "uncertaintyPenalty": 8
          },
          {
            "rank": 2,
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "utility": 65.69,
            "uncertaintyPenalty": 12
          },
          {
            "rank": 3,
            "scenarioId": "asteroid-first",
            "name": "Asteroid Feedstock-first",
            "utility": 51.37,
            "uncertaintyPenalty": 18
          },
          {
            "rank": 4,
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "utility": 42.95,
            "uncertaintyPenalty": 24
          },
          {
            "rank": 5,
            "scenarioId": "mars-first",
            "name": "Mars-first Conventional Expansion",
            "utility": 40.78,
            "uncertaintyPenalty": 12
          },
          {
            "rank": 6,
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "utility": 37.95,
            "uncertaintyPenalty": 26
          }
        ],
        "paretoFrontier": [
          "moon-first"
        ],
        "inputHashes": {
          "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
          "weights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
          "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
          "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
          "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f"
        },
        "evidenceHashes": {
          "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
          "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
          "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
        },
        "replayContract": {
          "state": "reproducible-from-repo-generator",
          "generatorScript": "scripts/generate-model-run-ledger.mjs",
          "reproducibleCommand": "npm run science:runs",
          "verificationCommand": "node --test tests/model-run-ledger.test.mjs",
          "expectedSelectedScenarioId": "hybrid",
          "expectedRankOneScenarioId": "moon-first",
          "deterministicSeed": "run-hybrid-base-2026-06-19",
          "dependencyHashes": {
            "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
            "weights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
            "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
            "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
            "notebooks": "sha256-e3104b8559d83b86dace49650a0a3c6b6d975870f251929a408cf429b098251f",
            "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
            "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
            "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f"
          },
          "outputPath": "public/model-run-ledger.json",
          "replayBoundary": "This replays deterministic planning logic only. It does not generate external SPICE/Orekit/GMAT/Tudat physics artifacts or promote commercial claims."
        },
        "promotionBlockers": [
          "Cost and schedule outputs are planning heuristics until dated cost-source records are attached.",
          "Trajectory/event-window claims require passing sidecar runtime artifacts.",
          "Asteroid resource claims require candidate-specific taxonomy, spectra, or mission evidence."
        ],
        "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207"
      }
    },
    "modelRunComparisons": {
      "mode": "deterministic-model-run-comparison-ledger",
      "comparisonCount": 2,
      "selectedScenarioChangeCount": 2,
      "rankOneChangeCount": 0,
      "commercialUseAllowed": false,
      "ledgerHash": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
      "comparisons": [
        {
          "id": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
          "baselineRunId": "run-hybrid-base-2026-06-19",
          "comparisonRunId": "run-conservative-moon-first-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
        },
        {
          "id": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
          "baselineRunId": "run-hybrid-base-2026-06-19",
          "comparisonRunId": "run-asteroid-feedstock-probe-2026-06-19",
          "selectedScenarioChanged": true,
          "rankOneChanged": false,
          "biggestRankMover": {
            "scenarioId": "moon-first",
            "rankDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "biggestUtilityMover": {
            "scenarioId": "moon-first",
            "utilityDelta": 0,
            "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
          },
          "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
        }
      ]
    },
    "customerDecisionDossiers": {
      "mode": "deterministic-customer-decision-dossier-ledger",
      "scenarioCount": 6,
      "paidBetaDossierCount": 1,
      "blockedDossierCount": 6,
      "customerReviewReadyCount": 0,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "ledgerHash": "sha256-fe0cb326f94ee79eb42dbe94b45e2166cc90cd1c6efc4d32ac0065292d74b669",
      "selectedScenarioDossier": {
        "id": "customer-dossier-hybrid",
        "scenarioId": "hybrid",
        "name": "Hybrid Moon -> Asteroid -> Mercury",
        "rank": 2,
        "generatedAt": "2026-06-21T00:00:00.000Z",
        "customerUseState": "research-backlog-only",
        "commercialUseAllowed": false,
        "buyerUseBoundary": "Use only as research backlog intelligence until scenario evidence, runtime validation, and source-use gates improve.",
        "decisionLane": "lane-3-watchlist",
        "promotionState": "blocked-for-commercial-proof",
        "summary": "Bootstrap close, screen feedstock, then scale toward Mercury energy advantage.",
        "metrics": {
          "deterministicUtility": 65.69,
          "decisionReadinessScore": 59.78,
          "utilityP10": 63.32,
          "utilityMedian": 65.48,
          "utilityP90": 67.6,
          "winProbability": 25.39,
          "uncertaintyBudgetPoints": 43.88,
          "uncertaintyClass": "medium-uncertainty",
          "businessReadinessMedian": 72.59,
          "medianCapitalGapBn": 0
        },
        "evidenceState": {
          "supportingClaimCount": 3,
          "blockedClaimCount": 3,
          "sourceUseCustomerAllowed": false,
          "promotedRuntimeContracts": 2,
          "readyRuntimeContracts": 0,
          "blockedRuntimeContracts": 3,
          "modelRunComparisonCount": 2,
          "tracePromotionState": "blocked-for-commercial-proof"
        },
        "supportingClaims": [
          {
            "claimId": "claim-mercury-flux",
            "domain": "Energy",
            "evidenceGrade": "A-reviewable",
            "promotionState": "verified-citable-beta-evidence",
            "claimHash": "sha256-e3e8588104f55cb37ed9439f59b32488dd0e4d32b515d016829a4c1329ab2373"
          },
          {
            "claimId": "claim-de440-boundary",
            "domain": "Ephemeris",
            "evidenceGrade": "A-reviewable",
            "promotionState": "verified-citable-beta-evidence",
            "claimHash": "sha256-6c37ab9ed51e6c9441c34b807fc9676d53067a1b166170e9d7c6aedc5ba3d6bb"
          },
          {
            "claimId": "claim-dtn",
            "domain": "Comms",
            "evidenceGrade": "A-reviewable",
            "promotionState": "verified-citable-beta-evidence",
            "claimHash": "sha256-493fc9b2aaac23b0fac4e0a6fffd13ab39e24171f3cf7d76c54e4c5d72cead46"
          }
        ],
        "blockedClaims": [
          {
            "claimId": "claim-helium3",
            "domain": "Resources",
            "blockerCount": 2,
            "claimHash": "sha256-71537b51e603e24fc6103af7b38ccaf4bacfb450d1fc84b9bb597d48a39030e4"
          },
          {
            "claimId": "claim-spf-separation",
            "domain": "Manufacturing",
            "blockerCount": 3,
            "claimHash": "sha256-81f6ffafef75eaa6230d056134cdb07efbba66111c45b0a185d4e6bd9a332359"
          },
          {
            "claimId": "claim-mercury-core",
            "domain": "Resources",
            "blockerCount": 3,
            "claimHash": "sha256-8140b7285ce9bc5f8ec408dc727e524d0cd5a65a185153bc47542a6f3fdb27f9"
          }
        ],
        "runRefs": [
          {
            "id": "run-hybrid-base-2026-06-19",
            "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
            "selectedUtility": 65.69,
            "claimState": "model-derived-unvalidated"
          }
        ],
        "modelRunComparisons": [
          {
            "comparisonId": "run-hybrid-base-2026-06-19__vs__run-conservative-moon-first-2026-06-19",
            "selectedScenarioChanged": true,
            "rankOneChanged": false,
            "biggestRankMover": {
              "scenarioId": "moon-first",
              "rankDelta": 0,
              "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
            },
            "biggestUtilityMover": {
              "scenarioId": "moon-first",
              "utilityDelta": 0,
              "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
            },
            "comparisonHash": "sha256-a4a89f96b3ec3e668f3b759bb5b75e72d86c3b85eb7cce142a3c9b7956fd7744"
          },
          {
            "comparisonId": "run-hybrid-base-2026-06-19__vs__run-asteroid-feedstock-probe-2026-06-19",
            "selectedScenarioChanged": true,
            "rankOneChanged": false,
            "biggestRankMover": {
              "scenarioId": "moon-first",
              "rankDelta": 0,
              "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
            },
            "biggestUtilityMover": {
              "scenarioId": "moon-first",
              "utilityDelta": 0,
              "scenarioDeltaHash": "sha256-84c1670685e42218807e186e64491626049abf9148db06880e482dc6b0555f23"
            },
            "comparisonHash": "sha256-e3ba912d138ed7037fb1fc55a6eedf0552a265d7e15e5c30d65966128e40d81a"
          }
        ],
        "proofToChangeAnswer": {
          "crossoverId": "crossover-hybrid-over-moon-first",
          "challengerScenarioId": "hybrid",
          "currentLeaderScenarioId": "moon-first",
          "requiredUtilityDelta": 1.43,
          "crossoverState": "mathematically-reachable-not-validated",
          "topLeverPaths": [
            {
              "kind": "uncertainty-reduction",
              "criterion": "uncertaintyPenalty",
              "currentValue": 12,
              "direction": "decrease",
              "utilityPerPoint": 0.42,
              "requiredRawDelta": 3.4,
              "feasibleByRawRange": true,
              "headroom": 12
            },
            {
              "kind": "risk-reduction",
              "criterion": "transport",
              "currentValue": 46,
              "direction": "decrease",
              "utilityPerPoint": 0.1378,
              "requiredRawDelta": 10.38,
              "feasibleByRawRange": true,
              "headroom": 46
            },
            {
              "kind": "risk-reduction",
              "criterion": "feedstock",
              "currentValue": 55,
              "direction": "decrease",
              "utilityPerPoint": 0.1378,
              "requiredRawDelta": 10.38,
              "feasibleByRawRange": true,
              "headroom": 55
            }
          ],
          "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
        },
        "topUncertaintyDrivers": [
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 10.68,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "contributionHash": "sha256-1113356c45a9d66efb46dd79ad7e995ce35753fd92106e8a62a123e46e0c609a"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 9.66,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "contributionHash": "sha256-4e70a0f224a6884c44ccdf9a653d574034fb8de4a78ea8dafb4b627c42b51d72"
          },
          {
            "category": "resource-evidence",
            "label": "Body/feedstock composition uncertainty",
            "contributionPoints": 9.5,
            "evidenceState": "blocked-resource-promotion",
            "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "contributionHash": "sha256-07a08f8b629617090c595a9abaae19c858d1033775537f967bec618d3b525523"
          },
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 6.5,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
          }
        ],
        "topEvidenceGaps": [
          {
            "id": "gap-runtime-orekit-propagation-v1",
            "category": "runtime-sidecar",
            "priorityLane": "P0-critical-path",
            "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
            "nextAction": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "gapHash": "sha256-d7b3370f7e30f22d9384b036fb636c0360a352e5ad7477c300a9e2896af9901d"
          },
          {
            "id": "gap-runtime-gmat-transfer-v1",
            "category": "runtime-sidecar",
            "priorityLane": "P0-critical-path",
            "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
            "nextAction": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "gapHash": "sha256-db779e0c99ffc0487e63be269cff1d79a58b41e37c1c765b0ccee4aacda80d00"
          },
          {
            "id": "gap-runtime-tudat-transfer-v1",
            "category": "runtime-sidecar",
            "priorityLane": "P0-critical-path",
            "customerImpact": "Unlocks mission-design/event-window credibility for scenario diligence.",
            "nextAction": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "gapHash": "sha256-b64edfc79fc195cc5cda74710de1093987b73bb67395866b1a72d3410d82801b"
          },
          {
            "id": "gap-materials-process-oxygen-isru",
            "category": "materials-process",
            "priorityLane": "P1-business-grade",
            "customerImpact": "Required before manufacturability, process-fit, throughput, quality, or process-cost claims can be made.",
            "nextAction": "Promote reviewed material records and Cantera chemistry/thermodynamics run for Oxygen Extraction / ISRU.",
            "gapHash": "sha256-1f55d0f9489776748af577f74f69ae6b3de31dc0cda3196c52dd1ddfe4ae6149"
          }
        ],
        "blockers": [
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
          "assumption-sensitivity: Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "resource-evidence: Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "runtime-sidecar: Promote runtime sidecar artifacts through the sidecar validation gate.",
          "Asteroid/resource candidates are not promoted for resource claims.",
          "Claim claim-helium3: blocked-for-commercial-proof",
          "Customer-facing use remains blocked until source-use review approves cited sources.",
          "3 runtime sidecar contract(s) still block mission-design promotion."
        ],
        "nextProofActions": [
          "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
          "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
          "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
          "Promote runtime sidecar artifacts through the sidecar validation gate.",
          "Approve source-use review packets before customer-facing redistribution or derived-value claims.",
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
        ],
        "evidenceHashes": {
          "scenarioDecisionLedger": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
          "scenarioTraceabilityMatrix": "sha256-7623fbca52cfe5d3f3bc9d38df0be662a82c990b2776c01d7da3521756eff5a6",
          "scenarioDecisionAuditLedger": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
          "scenarioCrossoverFrontier": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1",
          "scenarioUncertaintyBudgetLedger": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
          "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
          "modelRunComparisonLedger": "sha256-1e7530f030dd80804d867901fd6c5f504f4d4ac5125ee82a2f6484dd0d6ae23d",
          "claimEvidenceLedger": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
          "evidenceGapPriorityLedger": "sha256-0d96cc2ff9254f569ef8adbc51ba340f18dd55f15b5a02ce9adecdc6291e17a7",
          "sourceUseRightsLedger": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
          "sidecarReadinessLedger": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8"
        },
        "dossierHash": "sha256-68d0fdd4692e07134d9e8f84753771b5b6328a6f909be6add5a81767f9346dbb"
      }
    },
    "economicsEvidenceLedger": {
      "mode": "deterministic-economics-evidence-ledger",
      "recordCount": 5,
      "blockedRecordCount": 5,
      "promotionAllowed": false,
      "ledgerHash": "sha256-676c2d6d270fb909cf21a482178ffcf177df30d095d6c55f918afe08bf6a9297",
      "linkedAssumptions": [
        {
          "id": "assumption-no-mercury-first",
          "state": "validated-product-rule",
          "uncertainty": "Low"
        },
        {
          "id": "assumption-launch-cost-ranges",
          "state": "hypothesis",
          "uncertainty": "High"
        }
      ]
    },
    "materialsProcessEvidenceLedger": {
      "mode": "deterministic-materials-process-evidence-ledger",
      "processCount": 3,
      "blockedProcessCount": 3,
      "promotionAllowed": false,
      "ledgerHash": "sha256-860c27709b9c2e64ffb883271d74cf5b6e44d14c8c8d2c22404f2adda2914f80",
      "topProcessGaps": [
        {
          "processId": "spf-db",
          "processName": "Superplastic Forming / Diffusion Bonding",
          "evidenceScore": 58,
          "bestScenarioId": "hybrid",
          "blockerCount": 3,
          "nextAction": "thermal cycle energy balance"
        },
        {
          "processId": "vacuum-sheet",
          "processName": "Vacuum Anisotropic Sheet Manufacturing",
          "evidenceScore": 61,
          "bestScenarioId": "hybrid",
          "blockerCount": 3,
          "nextAction": "MOOSE thermo-mechanical forming residual record"
        },
        {
          "processId": "oxygen-isru",
          "processName": "Oxygen Extraction / ISRU",
          "evidenceScore": 64,
          "bestScenarioId": "hybrid",
          "blockerCount": 3,
          "nextAction": "Cantera chemistry/thermodynamics run"
        }
      ]
    },
    "spaceEnvironmentEvidenceLedger": {
      "mode": "deterministic-space-environment-evidence-ledger",
      "recordCount": 4,
      "blockedRecordCount": 4,
      "promotionAllowed": false,
      "ledgerHash": "sha256-a45943c076c97fa1f272a6364e43c31246d59678bb7b47044aff195870853d23",
      "topEnvironmentGaps": [
        {
          "id": "ccmc-space-weather-model-run",
          "label": "NASA CCMC model-run custody",
          "evidenceScore": 63,
          "highestStressScenarioId": "mercury-orbit",
          "highestEnvironmentBurden": 80,
          "blockerCount": 3,
          "nextAction": "model selection and version"
        },
        {
          "id": "swpc-product-forecast-archive-context",
          "label": "NOAA SWPC dated product and alert context",
          "evidenceScore": 63,
          "highestStressScenarioId": "mercury-orbit",
          "highestEnvironmentBurden": 80,
          "blockerCount": 3,
          "nextAction": "product id and issue timestamp"
        },
        {
          "id": "spdf-cdaweb-radiation-plasma-intake",
          "label": "NASA SPDF/CDAWeb radiation and plasma source intake",
          "evidenceScore": 66,
          "highestStressScenarioId": "mercury-orbit",
          "highestEnvironmentBurden": 80,
          "blockerCount": 3,
          "nextAction": "CDAWeb dataset id and variable list"
        },
        {
          "id": "dtn-comms-disruption-architecture",
          "label": "DTN and space-data standards disruption architecture",
          "evidenceScore": 66,
          "highestStressScenarioId": "mercury-orbit",
          "highestEnvironmentBurden": 80,
          "blockerCount": 3,
          "nextAction": "selected standard or architecture document"
        }
      ],
      "capabilityContext": {
        "id": "space-environment",
        "maturityScore": 65.22,
        "maturityBand": "research-backed",
        "commercializationAllowed": false,
        "blockerCount": 1
      }
    },
    "asteroidCandidateEvidenceLedger": {
      "mode": "deterministic-asteroid-candidate-evidence-ledger",
      "candidateCount": 3,
      "blockedCandidateCount": 3,
      "promotionAllowed": false,
      "ledgerHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
      "globalBlockers": [
        "Synthetic candidates must be replaced with object-specific SBDB/CAD records.",
        "CAD geometry candidate evidence exists only as screening input until live capture and reviewer approval pass.",
        "MPC observation context must be attached where orbit confidence affects resource decisions.",
        "Taxonomy, spectra, or mission/archive products are required before composition can promote.",
        "Close approach frequency and low v-infinity are logistics signals, not resource evidence."
      ]
    },
    "candidateSourcePromotionLedger": {
      "mode": "deterministic-candidate-source-promotion-ledger",
      "reportCount": 1,
      "validReportCount": 1,
      "sourceCustodyPromotedCount": 0,
      "resourcePromotedCount": 0,
      "customerUseAllowedCount": 0,
      "sourceCustodyPromotionAllowed": false,
      "resourcePromotionAllowed": false,
      "customerUseAllowed": false,
      "promotionState": "blocked-no-candidate-source-custody",
      "workOrderGapCount": 10,
      "ledgerHash": "sha256-29496b525d4ca2eb53ff80af01f0b474def2f6876ecc381c796afd9a1c68188a",
      "topWorkOrderGaps": [
        {
          "workOrderId": "small-body-source-work-order-2026-jm2",
          "sourceCandidateId": "cad-2026 JM2",
          "designation": "2026 JM2",
          "name": "2026 JM2",
          "queueRank": 1,
          "reviewPriorityScore": 52.39,
          "reason": "No candidate-specific reviewed source custody intake has passed.",
          "requiredIntakeArtifacts": [
            "SBDB object payload with raw and normalized hashes.",
            "CAD candidate payload with raw and normalized hashes.",
            "MPC observation/designation bridge receipt.",
            "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
            "Source-use rights review before any customer-facing export."
          ],
          "outputContract": {
            "payloadPath": "evidence/source-candidate-payloads/2026-jm2-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-jm2-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
          },
          "workOrderHash": "sha256-b52331ce9a5cd6c17d6aafaa4119aee5533301a87cded5d6a06e684cf07fa134"
        },
        {
          "workOrderId": "small-body-source-work-order-2026-em",
          "sourceCandidateId": "cad-2026 EM",
          "designation": "2026 EM",
          "name": "2026 EM",
          "queueRank": 2,
          "reviewPriorityScore": 44.28,
          "reason": "No candidate-specific reviewed source custody intake has passed.",
          "requiredIntakeArtifacts": [
            "SBDB object payload with raw and normalized hashes.",
            "CAD candidate payload with raw and normalized hashes.",
            "MPC observation/designation bridge receipt.",
            "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
            "Source-use rights review before any customer-facing export."
          ],
          "outputContract": {
            "payloadPath": "evidence/source-candidate-payloads/2026-em-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-em-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
          },
          "workOrderHash": "sha256-5bdb8eb61a495b8a9b53e1cfc73fb5ccdbb5ad0910d3db8a4584ed501c2616f9"
        },
        {
          "workOrderId": "small-body-source-work-order-2026-dn5",
          "sourceCandidateId": "cad-2026 DN5",
          "designation": "2026 DN5",
          "name": "2026 DN5",
          "queueRank": 3,
          "reviewPriorityScore": 39.5,
          "reason": "No candidate-specific reviewed source custody intake has passed.",
          "requiredIntakeArtifacts": [
            "SBDB object payload with raw and normalized hashes.",
            "CAD candidate payload with raw and normalized hashes.",
            "MPC observation/designation bridge receipt.",
            "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
            "Source-use rights review before any customer-facing export."
          ],
          "outputContract": {
            "payloadPath": "evidence/source-candidate-payloads/2026-dn5-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-dn5-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
          },
          "workOrderHash": "sha256-620143df6681d87f5385af49ebf5ccc6bd18b20679f3e5e292185d1b5f0327d0"
        },
        {
          "workOrderId": "small-body-source-work-order-2026-lx",
          "sourceCandidateId": "cad-2026 LX",
          "designation": "2026 LX",
          "name": "2026 LX",
          "queueRank": 4,
          "reviewPriorityScore": 39.44,
          "reason": "No candidate-specific reviewed source custody intake has passed.",
          "requiredIntakeArtifacts": [
            "SBDB object payload with raw and normalized hashes.",
            "CAD candidate payload with raw and normalized hashes.",
            "MPC observation/designation bridge receipt.",
            "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
            "Source-use rights review before any customer-facing export."
          ],
          "outputContract": {
            "payloadPath": "evidence/source-candidate-payloads/2026-lx-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-lx-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
          },
          "workOrderHash": "sha256-8c14435b45122ce12954b3cdff703649a3c597e4399f447c3d66d06c0615617e"
        },
        {
          "workOrderId": "small-body-source-work-order-2026-ku1",
          "sourceCandidateId": "cad-2026 KU1",
          "designation": "2026 KU1",
          "name": "2026 KU1",
          "queueRank": 5,
          "reviewPriorityScore": 36.59,
          "reason": "No candidate-specific reviewed source custody intake has passed.",
          "requiredIntakeArtifacts": [
            "SBDB object payload with raw and normalized hashes.",
            "CAD candidate payload with raw and normalized hashes.",
            "MPC observation/designation bridge receipt.",
            "Taxonomy, spectra, mission, or archive evidence packet, or explicit no-evidence-found receipt.",
            "Source-use rights review before any customer-facing export."
          ],
          "outputContract": {
            "payloadPath": "evidence/source-candidate-payloads/2026-ku1-source-intake-payload.json",
            "reportPath": "evidence/source-candidate-reports/2026-ku1-source-intake-report.json",
            "verificationCommand": "node --test tests/asteroid-candidate-evidence-ledger.test.mjs tests/live-small-body-review-queue.test.mjs",
            "promotionBoundary": "This work order can promote source custody only after review. It cannot promote resource composition without candidate-specific taxonomy, spectra, or mission/archive evidence."
          },
          "workOrderHash": "sha256-9f67dd23c5090587d15155d69e13638d980daaa9b46e66af99b0a82c007689d3"
        }
      ]
    },
    "candidateSourceClosurePackets": {
      "mode": "deterministic-candidate-source-closure-packets",
      "packetCount": 10,
      "draftIntakePresentCount": 10,
      "missingIntakeArtifactCount": 0,
      "sourceCustodyBlockedCount": 10,
      "resourcePromotionBlockedCount": 10,
      "customerUseBlockedCount": 10,
      "packetHash": "sha256-8a53a4e3a8d6fb35dc1e3001ea5958724fd734415b1735163fae5d2ecc543608",
      "topPackets": [
        {
          "id": "candidate-source-closure-packet-2026-jm2",
          "designation": "2026 JM2",
          "intakeState": "draft-intake-present-fail-closed",
          "requiredClosureItemCount": 6,
          "packetHash": "sha256-b8c9884921e96895d07fd3d092019180bf1216464d394737fc23d9ae2d95fa08"
        },
        {
          "id": "candidate-source-closure-packet-2026-em",
          "designation": "2026 EM",
          "intakeState": "draft-intake-present-fail-closed",
          "requiredClosureItemCount": 6,
          "packetHash": "sha256-5fe6fb4a6dbb2dab31c843b41f2f8ea0bf38970f6b37602b3057f57ec166f476"
        },
        {
          "id": "candidate-source-closure-packet-2026-dn5",
          "designation": "2026 DN5",
          "intakeState": "draft-intake-present-fail-closed",
          "requiredClosureItemCount": 6,
          "packetHash": "sha256-1f658a0d55749a22f8502fb8da9afc75587853bf55d17d44a1b27c8f151ad35e"
        }
      ]
    },
    "trajectoryResidualAcceptanceLedger": {
      "mode": "deterministic-trajectory-residual-acceptance-ledger",
      "residualAcceptanceCount": 4,
      "blockedResidualAcceptanceCount": 4,
      "decisionUseAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "ledgerHash": "sha256-9e26a7e1dced7bbea21083bedeece1f325015a72d27f84aa46c763b6e523dcd4",
      "topAcceptanceRecords": [
        {
          "id": "residual-orekit-gmat-hybrid-transfer",
          "currentState": "blocked-pending-runtime-and-delta-evidence",
          "comparisonType": "independent-trajectory-tool-residual",
          "blockerCount": 10,
          "acceptanceHash": "sha256-f3f9f54a0f91ab7a185c95642523ea18222d1e2e2571ce6dc8aab4d9c43f2788"
        },
        {
          "id": "residual-orekit-tudat-cross-check",
          "currentState": "blocked-pending-runtime-and-delta-evidence",
          "comparisonType": "cross-tool-propagation-residual",
          "blockerCount": 10,
          "acceptanceHash": "sha256-5b9cf17473ee98df49f02252ec16baa1147374c43a019439748a37e736c8df89"
        },
        {
          "id": "residual-gmat-tudat-transfer-check",
          "currentState": "blocked-pending-runtime-and-delta-evidence",
          "comparisonType": "mission-design-to-propagator-residual",
          "blockerCount": 8,
          "acceptanceHash": "sha256-bac90bd796faf3f75506f843128a8fe3ad946b52e68e3f6004fd9421ae9d0f7c"
        }
      ]
    },
    "trajectoryResidualEvidenceLedger": {
      "mode": "deterministic-trajectory-residual-evidence-ledger",
      "acceptanceLaneCount": 4,
      "reportCount": 0,
      "promotedResidualEvidenceCount": 0,
      "blockedLaneCount": 4,
      "promotionAllowed": false,
      "decisionUseAllowed": false,
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "ledgerHash": "sha256-eff8e56cec9a8a20a9ed2b19825f3d35f7d3b019262cf01b8ba64f15e1cf9785",
      "topLaneRecords": [
        {
          "id": "residual-orekit-gmat-hybrid-transfer",
          "evidenceState": "blocked-no-promoted-residual-evidence",
          "blockerCount": 11,
          "laneEvidenceHash": "sha256-e501027474c1c94324d2d8ff72e21225a441eefdbf408dbcd9406c73d21238e4"
        },
        {
          "id": "residual-orekit-tudat-cross-check",
          "evidenceState": "blocked-no-promoted-residual-evidence",
          "blockerCount": 11,
          "laneEvidenceHash": "sha256-0779042021ee5c3134ebd3bac82ec00efb8dbdf9e93b3521f0845773cead6f9f"
        },
        {
          "id": "residual-gmat-tudat-transfer-check",
          "evidenceState": "blocked-no-promoted-residual-evidence",
          "blockerCount": 9,
          "laneEvidenceHash": "sha256-e1081c4733de45504ecb853e92247fa5f138c623937463cdc1cb897ce4b0c5c2"
        }
      ]
    },
    "assumptionImpactLedger": {
      "mode": "deterministic-assumption-impact-ledger",
      "assumptionCount": 5,
      "blockedAssumptionCount": 3,
      "ledgerHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
      "mostSensitiveAssumptions": [
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "maxRankShift": 0,
          "maxUtilityDelta": 1.68,
          "reviewState": "blocked-for-business-proof"
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "maxRankShift": 0,
          "maxUtilityDelta": 0.67,
          "reviewState": "blocked-for-business-proof"
        },
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "maxRankShift": 0,
          "maxUtilityDelta": 0.46,
          "reviewState": "reviewable"
        }
      ]
    },
    "scenarioDecisionLedger": {
      "mode": "deterministic-scenario-decision-ledger",
      "scenarioCount": 6,
      "ledgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
      "topDecision": {
        "scenarioId": "moon-first",
        "decisionLane": "lane-2-conditional-diligence",
        "decisionReadinessScore": 62.91,
        "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
      },
      "selectedDecision": {
        "scenarioId": "hybrid",
        "name": "Hybrid Moon -> Asteroid -> Mercury",
        "rank": 2,
        "summary": "Bootstrap close, screen feedstock, then scale toward Mercury energy advantage.",
        "deterministicScores": {
          "benefitScore": 80.53,
          "riskScore": 47.09,
          "uncertaintyPenalty": 12,
          "utility": 65.69
        },
        "decisionReadinessScore": 59.78,
        "decisionLane": "lane-3-watchlist",
        "commercializationAllowed": false,
        "promotionState": "blocked-for-commercial-proof",
        "runtimeEvidence": {
          "requiredContractCount": 5,
          "promotedContractCount": 2,
          "blockedContractCount": 3,
          "coveragePercent": 40,
          "evidenceState": "blocked-scenario-runtime-contract-gaps",
          "requiredContractIds": [
            "spice-gf-event-window-v1",
            "orekit-propagation-v1",
            "gmat-transfer-v1",
            "tudat-transfer-v1",
            "openmdao-dymos-optimization-v1"
          ],
          "blockedContractIds": [
            "orekit-propagation-v1",
            "gmat-transfer-v1",
            "tudat-transfer-v1"
          ],
          "requirements": [
            {
              "contractId": "spice-gf-event-window-v1",
              "tool": "NASA NAIF SPICE Geometry Finder",
              "domain": "ephemeris-event-windows",
              "requiredForScenario": "hybrid",
              "promotionAllowed": true,
              "evidenceState": "runtime-evidence-promoted",
              "promotedArtifactIds": [
                "spice-gf-runtime-mercury-clear-link-22deg-2025",
                "spice-gf-runtime-mercury-clear-link-nonzero-window-proof-2025-08"
              ],
              "promotedValidationHashes": [
                "sha256-b821956c87d700973de4b729e8521d88236ca7879136d54efa0e4efa32686d3c",
                "sha256-0e447e7bc3b17a578af3a924a9419b42ea2bf2c23ccd6127e6bf9fd0a5a4528c"
              ],
              "promotionRule": "Artifact may be reviewed for claim promotion.",
              "requirementHash": "sha256-feb8557a9208514bcded44f617bd4626ef9059a1050639519b57d26e639e9dcc"
            },
            {
              "contractId": "orekit-propagation-v1",
              "tool": "Orekit",
              "domain": "trajectory-propagation",
              "requiredForScenario": "hybrid",
              "promotionAllowed": false,
              "evidenceState": "blocked-missing-runtime-evidence",
              "promotedArtifactIds": [],
              "promotedValidationHashes": [],
              "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
              "requirementHash": "sha256-2b8e2794d126e12f1977d2637f81df5f1f3cfd3e745af3e48d43d3ec4711f0a3"
            },
            {
              "contractId": "gmat-transfer-v1",
              "tool": "NASA GMAT",
              "domain": "mission-design-transfer",
              "requiredForScenario": "hybrid",
              "promotionAllowed": false,
              "evidenceState": "blocked-missing-runtime-evidence",
              "promotedArtifactIds": [],
              "promotedValidationHashes": [],
              "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
              "requirementHash": "sha256-52a2c986ce18cf723f04425e3ae22aabbbd2e9bd0ac82ba03f1f5794ac1d37c3"
            },
            {
              "contractId": "tudat-transfer-v1",
              "tool": "Tudat",
              "domain": "cross-tool-trajectory-validation",
              "requiredForScenario": "hybrid",
              "promotionAllowed": false,
              "evidenceState": "blocked-missing-runtime-evidence",
              "promotedArtifactIds": [],
              "promotedValidationHashes": [],
              "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
              "requirementHash": "sha256-37d07018e2579aea5170e47e979ff23394cb6392f2fee28e3c6f43ec695c3bce"
            },
            {
              "contractId": "openmdao-dymos-optimization-v1",
              "tool": "OpenMDAO/Dymos",
              "domain": "optimization-and-sensitivity",
              "requiredForScenario": "hybrid",
              "promotionAllowed": true,
              "evidenceState": "runtime-evidence-promoted",
              "promotedArtifactIds": [
                "openmdao-dymos-runtime-moon-logistics-beta-optimization"
              ],
              "promotedValidationHashes": [
                "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7"
              ],
              "promotionRule": "Artifact may be reviewed for claim promotion.",
              "requirementHash": "sha256-c3715076ab910f4097e7d37e6a2991427456b44d261f6b7bf7b8c997f6457fbd"
            }
          ]
        },
        "topBenefitDrivers": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 92,
            "weight": 1,
            "weightedValue": 92
          },
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          }
        ],
        "topRiskDrivers": [
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 55,
            "weight": 1,
            "weightedValue": 55
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 46,
            "weight": 1,
            "weightedValue": 46
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 45,
            "weight": 0.9,
            "weightedValue": 40.5
          }
        ],
        "allDrivers": {
          "benefits": [
            {
              "kind": "benefit",
              "criterion": "optionality",
              "rawScore": 92,
              "weight": 1,
              "weightedValue": 92
            },
            {
              "kind": "benefit",
              "criterion": "energy",
              "rawScore": 82,
              "weight": 1,
              "weightedValue": 82
            },
            {
              "kind": "benefit",
              "criterion": "processFit",
              "rawScore": 82,
              "weight": 1,
              "weightedValue": 82
            },
            {
              "kind": "benefit",
              "criterion": "resourceConfidence",
              "rawScore": 68,
              "weight": 1,
              "weightedValue": 68
            },
            {
              "kind": "benefit",
              "criterion": "vacuum",
              "rawScore": 78,
              "weight": 0.75,
              "weightedValue": 58.5
            }
          ],
          "risks": [
            {
              "kind": "risk",
              "criterion": "feedstock",
              "rawScore": 55,
              "weight": 1,
              "weightedValue": 55
            },
            {
              "kind": "risk",
              "criterion": "transport",
              "rawScore": 46,
              "weight": 1,
              "weightedValue": 46
            },
            {
              "kind": "risk",
              "criterion": "thermal",
              "rawScore": 45,
              "weight": 0.9,
              "weightedValue": 40.5
            },
            {
              "kind": "risk",
              "criterion": "processMaturity",
              "rawScore": 46,
              "weight": 0.8,
              "weightedValue": 36.8
            },
            {
              "kind": "risk",
              "criterion": "comms",
              "rawScore": 42,
              "weight": 0.8,
              "weightedValue": 33.6
            }
          ]
        },
        "uncertainty": {
          "iterations": 128,
          "utilityP10": 63.58,
          "utilityMedian": 65.8,
          "utilityP90": 67.74,
          "downsideSpread": 2.22,
          "seed": "hybrid-decision-ledger"
        },
        "economics": {
          "businessReadinessMedian": 72.59,
          "businessReadinessP10": 66.95,
          "businessReadinessP90": 78.5,
          "medianProgramNeedBn": 61.38,
          "medianCapitalGapBn": 0,
          "winProbabilityPercent": 24.22,
          "underfundedProbabilityPercent": 0.39
        },
        "assumptionImpacts": [
          {
            "assumptionId": "assumption-snapshot-first",
            "title": "Browser consumes reviewed snapshots first",
            "state": "validated-product-rule",
            "uncertainty": "Low",
            "reviewState": "reviewable",
            "promotionAllowed": true,
            "utilityDelta": -0.21,
            "rankDelta": 0,
            "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
          },
          {
            "assumptionId": "assumption-no-mercury-first",
            "title": "Mercury cannot be hardcoded as the winning scenario",
            "state": "validated-product-rule",
            "uncertainty": "Low",
            "reviewState": "reviewable",
            "promotionAllowed": true,
            "utilityDelta": 0.16,
            "rankDelta": 0,
            "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
          },
          {
            "assumptionId": "assumption-resource-composition-unknown",
            "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
            "state": "blocked-until-source-backed",
            "uncertainty": "High",
            "reviewState": "blocked-for-business-proof",
            "promotionAllowed": false,
            "utilityDelta": -0.86,
            "rankDelta": 0,
            "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
          },
          {
            "assumptionId": "assumption-social-signals-market-only",
            "title": "Forums and social platforms are market signals, not science evidence",
            "state": "approved-governance-rule",
            "uncertainty": "Low",
            "reviewState": "blocked-for-business-proof",
            "promotionAllowed": false,
            "utilityDelta": -0.07,
            "rankDelta": 0,
            "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
          },
          {
            "assumptionId": "assumption-launch-cost-ranges",
            "title": "Launch economics must use dated ranges and sensitivity bands",
            "state": "hypothesis",
            "uncertainty": "High",
            "reviewState": "blocked-for-business-proof",
            "promotionAllowed": false,
            "utilityDelta": -0.07,
            "rankDelta": 0,
            "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
          }
        ],
        "blockedAssumptionCount": 3,
        "runRefs": [
          {
            "id": "run-hybrid-base-2026-06-19",
            "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
            "claimState": "model-derived-unvalidated",
            "selectedUtility": 65.69
          }
        ],
        "blockers": [
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
        ],
        "requiredNextEvidence": [
          "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
          "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
          "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
        ],
        "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
      }
    },
    "scenarioDecisionAuditLedger": {
      "mode": "deterministic-scenario-decision-audit-ledger",
      "auditCount": 6,
      "commercialUseAllowed": false,
      "ledgerHash": "sha256-866e7246e717b7f2c4f1f2b6a0be137698a79cf20280f3781e780e8d959cca00",
      "leaderScenarioId": "moon-first",
      "topCrossoverQuestions": [
        {
          "scenarioId": "moon-first",
          "rank": 1,
          "decisionLane": "lane-2-conditional-diligence",
          "flipKind": "leader-loss-threshold",
          "requiredDelta": 1.43,
          "blockerCount": 18
        },
        {
          "scenarioId": "hybrid",
          "rank": 2,
          "decisionLane": "lane-3-watchlist",
          "flipKind": "challenger-crossover-threshold",
          "requiredDelta": 1.43,
          "blockerCount": 20
        },
        {
          "scenarioId": "asteroid-first",
          "rank": 3,
          "decisionLane": "lane-4-research-backlog",
          "flipKind": "challenger-crossover-threshold",
          "requiredDelta": 15.75,
          "blockerCount": 18
        },
        {
          "scenarioId": "mercury-orbit",
          "rank": 4,
          "decisionLane": "lane-4-research-backlog",
          "flipKind": "challenger-crossover-threshold",
          "requiredDelta": 24.17,
          "blockerCount": 24
        }
      ]
    },
    "scenarioCrossoverFrontier": {
      "mode": "deterministic-scenario-crossover-frontier-ledger",
      "commercialUseAllowed": false,
      "leaderScenarioId": "moon-first",
      "challengerCount": 5,
      "nearestCrossover": {
        "challengerScenarioId": "hybrid",
        "requiredUtilityDelta": 1.43,
        "crossoverState": "mathematically-reachable-not-validated",
        "crossoverHash": "sha256-3f18573eaa49677e7506a5604e505ffe279334d0b5f95dcfa82fd24a47342916"
      },
      "ledgerHash": "sha256-59e7ad43803aeedff01de819f78f249c076874a2ee34fe49e07030417db953f1"
    },
    "scenarioUncertaintyBudget": {
      "mode": "deterministic-scenario-uncertainty-budget-ledger",
      "scenarioCount": 6,
      "iterations": 256,
      "seed": "scenario-uncertainty-budget-v1",
      "commercialUseAllowed": false,
      "ledgerHash": "sha256-bc5d03c9507915ce3a6f2edfaf280eb7198445b0f5c015397a1893ba27342596",
      "highestUncertaintyScenario": {
        "scenarioId": "mercury-orbit",
        "uncertaintyBudgetPoints": 65.61,
        "uncertaintyClass": "high-uncertainty"
      },
      "selectedBudget": {
        "scenarioId": "hybrid",
        "uncertaintyBudgetPoints": 43.88,
        "uncertaintyClass": "medium-uncertainty",
        "topUncertaintyDrivers": [
          {
            "category": "model-spread",
            "label": "Seeded utility downside spread",
            "contributionPoints": 10.68,
            "evidenceState": "modeled-heuristic",
            "reducerProof": "Run validated sensitivity against promoted SPICE/Orekit/GMAT/Tudat and economics artifacts.",
            "linkedEvidenceHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13",
            "contributionHash": "sha256-1113356c45a9d66efb46dd79ad7e995ce35753fd92106e8a62a123e46e0c609a"
          },
          {
            "category": "assumption-sensitivity",
            "label": "Blocked or sensitive assumptions",
            "contributionPoints": 9.66,
            "evidenceState": "blocked-business-proof",
            "reducerProof": "Close assumption review gates with source-backed records and rerun assumption impact ledger.",
            "linkedEvidenceHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
            "contributionHash": "sha256-4e70a0f224a6884c44ccdf9a653d574034fb8de4a78ea8dafb4b627c42b51d72"
          },
          {
            "category": "resource-evidence",
            "label": "Body/feedstock composition uncertainty",
            "contributionPoints": 9.5,
            "evidenceState": "blocked-resource-promotion",
            "reducerProof": "Attach candidate/body-specific SBDB/CAD/taxonomy/spectra/mission data before resource promotion.",
            "linkedEvidenceHash": "sha256-3a4cf27fbcf60e16c76e5d5b2e16490e9dcfe393747d2678474c1f82d234af22",
            "contributionHash": "sha256-07a08f8b629617090c595a9abaae19c858d1033775537f967bec618d3b525523"
          },
          {
            "category": "runtime-sidecar",
            "label": "Trajectory/event/runtime validation gap",
            "contributionPoints": 6.5,
            "evidenceState": "blocked-runtime-evidence",
            "reducerProof": "Promote runtime sidecar artifacts through the sidecar validation gate.",
            "linkedEvidenceHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
            "contributionHash": "sha256-d252d3d9ee2efe620e142b4d9d979748aff8a080a03247b343b412a2fac70d80"
          }
        ],
        "budgetHash": "sha256-d595ef57fc29b1e7bf00950455c56c83e9f708dd12dd6c63c2d8c22b72a89869"
      }
    },
    "capabilityMaturityLedger": {
      "mode": "deterministic-capability-maturity-ledger",
      "capabilityCount": 9,
      "blockedCapabilityCount": 9,
      "commercializationAllowed": false,
      "ledgerHash": "sha256-f1dc7ec56ccebef2ce81f203d8973948478d7129005c65ef75c9cca15366defd",
      "topCapabilities": [
        {
          "id": "business-research-workflow",
          "maturityScore": 78.95,
          "maturityBand": "beta-reviewable",
          "commercializationAllowed": false
        },
        {
          "id": "evidence-provenance",
          "maturityScore": 78.94,
          "maturityBand": "beta-reviewable",
          "commercializationAllowed": false
        },
        {
          "id": "ephemeris-event-windows",
          "maturityScore": 65.49,
          "maturityBand": "research-backed",
          "commercializationAllowed": false
        }
      ],
      "globalBlockers": [
        "Runtime SPICE/Orekit/GMAT/Tudat artifacts are still required for mission-design promotion.",
        "Candidate-specific asteroid taxonomy/spectra/mission data is still required for resource promotion.",
        "Dated launch-cost, capex, opex, and market-source records are still required for economics promotion.",
        "Cantera/MOOSE/OpenFOAM process artifacts are still required before material/process scores become engineering evidence.",
        "SPDF/CCMC/SWPC environment artifacts are still required before radiation/space-weather assumptions promote."
      ]
    },
    "modelValidationProtocols": {
      "mode": "deterministic-model-validation-protocol-ledger",
      "protocolCount": 9,
      "blockedProtocolCount": 9,
      "commercialUseAllowed": false,
      "ledgerHash": "sha256-6aa23a5aebbeb63c2692898e189c7abcb422184f0a56de8653ae262f9b1f1db2",
      "stateCounts": {
        "beta-reviewable-non-commercial": 2,
        "blocked-validation-gaps": 7
      },
      "topProtocolGaps": [
        {
          "id": "protocol-ephemeris-event-windows",
          "domain": "ephemeris-event-windows",
          "title": "Ephemeris geometry and contact/event-window validation",
          "validationState": "blocked-validation-gaps",
          "blockerCount": 1,
          "nextAction": "Capability blocker: Runtime sidecar validation blocked: spice-gf-event-window-v1"
        },
        {
          "id": "protocol-small-body-feedstock",
          "domain": "small-body-feedstock",
          "title": "Small-body orbit, close-approach, and resource-candidate validation",
          "validationState": "blocked-validation-gaps",
          "blockerCount": 5,
          "nextAction": "Runtime sidecar artifact not promoted: orekit-propagation-v1"
        },
        {
          "id": "protocol-trajectory-logistics",
          "domain": "trajectory-logistics",
          "title": "Trajectory, transfer, and logistics cross-tool validation",
          "validationState": "blocked-validation-gaps",
          "blockerCount": 7,
          "nextAction": "Runtime sidecar artifact not promoted: orekit-propagation-v1"
        },
        {
          "id": "protocol-comms-autonomy",
          "domain": "comms-autonomy",
          "title": "Communications, blackout, and autonomy validation",
          "validationState": "blocked-validation-gaps",
          "blockerCount": 3,
          "nextAction": "Source payload not promoted: nasa-dtn"
        },
        {
          "id": "protocol-space-environment",
          "domain": "space-environment",
          "title": "Radiation, plasma, and solar-weather validation",
          "validationState": "blocked-validation-gaps",
          "blockerCount": 4,
          "nextAction": "Source payload not promoted: nasa-spdf"
        }
      ]
    },
    "workspaces": {
      "mode": "deterministic-research-workspace-ledger",
      "workspaceCount": 3,
      "blockedWorkspaceCount": 3,
      "ledgerHash": "sha256-06be4865541ea0844d8c870d423cee2f284e13b32cb3ae611d3f3d4278940755",
      "selectedWorkspaces": [
        {
          "id": "workspace-investor-feasibility-brief",
          "title": "Investor Feasibility Brief",
          "reviewStage": "beta-review",
          "workspaceHash": "sha256-39ce4c082cf5d7b374489dc8b8b7a54f6fb0192a04b3f993c9bc499629d3a035",
          "blockedGateCount": 2
        },
        {
          "id": "workspace-asteroid-feedstock-screen",
          "title": "Asteroid Feedstock Screen",
          "reviewStage": "blocked-by-source-depth",
          "workspaceHash": "sha256-af632045750b3b113f57cdad025a4ea3fe74018460b743bcf69eff71fee3b709",
          "blockedGateCount": 2
        },
        {
          "id": "workspace-science-validation-backlog",
          "title": "Science Validation Backlog",
          "reviewStage": "engineering-validation",
          "workspaceHash": "sha256-8cca8a7ea33436d40671577ca25734edbfcbd5eb1533fdfe7149cc3d23dc1e25",
          "blockedGateCount": 2
        }
      ]
    },
    "sidecarValidationReportHash": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
    "sidecarScaffoldRejectionLedgerHash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
    "sidecarWorkOrderPacketHash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
    "sourceIngestionLedgerHash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
    "sourceUseReviewPacketHash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
    "sourceUseRightsLedgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
    "sourceUseClearanceDossierHash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
    "sourceIngestionLedger": {
      "mode": "deterministic-source-ingestion-work-order-ledger",
      "sourceCount": 33,
      "workOrderCount": 33,
      "blockedWorkOrderCount": 33,
      "ledgerHash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2",
      "topPrioritySources": [
        {
          "id": "source-ingest-cad-api",
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "domain": "small-body-and-resource-evidence",
          "priority": "P0",
          "nextAction": "Capture a reviewed close-approach-api payload with raw and normalized hashes before this source can promote model outputs.",
          "workOrderHash": "sha256-ae487ba413cc055f5780b588f01397328e6b175869437d23576aad46b9b9ce71"
        },
        {
          "id": "source-ingest-dymos",
          "sourceId": "dymos",
          "title": "Dymos",
          "domain": "trajectory-and-optimization",
          "priority": "P0",
          "nextAction": "Capture a reviewed optimal-control-library payload with raw and normalized hashes before this source can promote model outputs.",
          "workOrderHash": "sha256-5f0c857d5f01ab9369fac47f0b965676cd1d5551ba22f91f1294e64872c344d0"
        },
        {
          "id": "source-ingest-esa-psa",
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "domain": "small-body-and-resource-evidence",
          "priority": "P0",
          "nextAction": "Capture a reviewed planetary-mission-archive payload with raw and normalized hashes before this source can promote model outputs.",
          "workOrderHash": "sha256-e943bde41a94f1789b36698e84beaf971e81fece7b2e6162591edfd8afdad615"
        },
        {
          "id": "source-ingest-gmat",
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "domain": "trajectory-and-optimization",
          "priority": "P0",
          "nextAction": "Capture a reviewed mission-analysis-tool payload with raw and normalized hashes before this source can promote model outputs.",
          "workOrderHash": "sha256-9dc7bf9fb79de628782cf8b0323b4f3813914992b426fe4dc7a3daf3eae8833d"
        },
        {
          "id": "source-ingest-horizons-api",
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "domain": "ephemeris-and-astronomy",
          "priority": "P0",
          "nextAction": "Capture a reviewed ephemeris-api payload with raw and normalized hashes before this source can promote model outputs.",
          "workOrderHash": "sha256-87c8e4bb328d92196995c2a99ceb331d2f9e3c6616f90eb5b75f48e3a1e8af10"
        }
      ],
      "globalBlockers": [
        "No source ingestion work order can promote until a reviewed raw payload and normalized output hash exist.",
        "Social/forum material remains market intelligence only unless bridged to primary records.",
        "Runtime science tools still require sidecar artifacts before mission-design promotion.",
        "Commercial/economics records still require dated normalization before ROI or investment claims."
      ]
    },
    "sourceUseRightsLedger": {
      "mode": "deterministic-source-use-rights-ledger",
      "sourceCount": 33,
      "blockedSourceUseCount": 33,
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "ledgerHash": "sha256-d1f63d6a716127db0069f74295cfd720976b3a15e5de3f62b0fe88c8238a6f57",
      "classCounts": {
        "standards-body-source": 4,
        "public-data-or-api-source": 15,
        "general-public-source": 5,
        "open-source-tool-or-code": 7,
        "commercial-public-source": 2
      },
      "riskCounts": {
        "medium": 31,
        "high": 2
      },
      "topReviewQueue": [
        {
          "sourceId": "spacex-rideshare",
          "title": "SpaceX Rideshare Program",
          "sourceUseClass": "commercial-public-source",
          "riskLevel": "high",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "captured terms or legal page hash"
        },
        {
          "sourceId": "nasa-clps",
          "title": "Commercial Lunar Payload Services",
          "sourceUseClass": "commercial-public-source",
          "riskLevel": "high",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "captured terms or legal page hash"
        },
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "sourceUseClass": "standards-body-source",
          "riskLevel": "medium",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "standard identifier and version"
        },
        {
          "sourceId": "horizons-api",
          "title": "JPL Horizons API",
          "sourceUseClass": "public-data-or-api-source",
          "riskLevel": "medium",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "terms page or archive citation"
        },
        {
          "sourceId": "horizons-mercury-2024",
          "title": "JPL Horizons Mercury Physical Data",
          "sourceUseClass": "public-data-or-api-source",
          "riskLevel": "medium",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "terms page or archive citation"
        },
        {
          "sourceId": "nist-codata",
          "title": "2022 CODATA Fundamental Physical Constants",
          "sourceUseClass": "general-public-source",
          "riskLevel": "medium",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "terms or license note"
        },
        {
          "sourceId": "sbdb-api",
          "title": "JPL Small-Body Database API",
          "sourceUseClass": "public-data-or-api-source",
          "riskLevel": "medium",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "terms page or archive citation"
        },
        {
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "sourceUseClass": "public-data-or-api-source",
          "riskLevel": "medium",
          "metadataCoverage": 100,
          "blockerCount": 4,
          "nextAction": "terms page or archive citation"
        }
      ]
    },
    "sourceUseReviewPackets": {
      "mode": "deterministic-source-use-review-packets",
      "packetCount": 33,
      "blockedPacketCount": 33,
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "packetHash": "sha256-510164d326f7598c8543b02a29a8d1aff756b61ea192e1f239b877aace4c6864",
      "priorityCounts": {
        "P2": 31,
        "P0": 2
      },
      "topReviewQueue": [
        {
          "id": "source-use-review-nasa-clps",
          "sourceId": "nasa-clps",
          "title": "Commercial Lunar Payload Services",
          "sourceUseClass": "commercial-public-source",
          "riskLevel": "high",
          "priority": "P0",
          "requiredDecisionCount": 6,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-4b3395cfcc70a4f4f0a78c7a0a54b16160a9808c0a58cd586d5085adf8dc28d7"
        },
        {
          "id": "source-use-review-spacex-rideshare",
          "sourceId": "spacex-rideshare",
          "title": "SpaceX Rideshare Program",
          "sourceUseClass": "commercial-public-source",
          "riskLevel": "high",
          "priority": "P0",
          "requiredDecisionCount": 6,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-9a7afed2d2517e5a7f3d6c0bb9dd58febf2fc8b7d3fe1236721d849b201c8d13"
        },
        {
          "id": "source-use-review-cad-api",
          "sourceId": "cad-api",
          "title": "SBDB Close Approach Data API",
          "sourceUseClass": "public-data-or-api-source",
          "riskLevel": "medium",
          "priority": "P2",
          "requiredDecisionCount": 5,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-5509ae5af4c25dc7a954e49ebf73395ea3b8195d3da643c0fdb45929575e9245"
        },
        {
          "id": "source-use-review-cantera",
          "sourceId": "cantera",
          "title": "Cantera",
          "sourceUseClass": "open-source-tool-or-code",
          "riskLevel": "medium",
          "priority": "P2",
          "requiredDecisionCount": 5,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-f8c02fcec876f0727bd2a3dd2898bfa468e397fbb04f5211bbbbcca27945f453"
        },
        {
          "id": "source-use-review-ccsds",
          "sourceId": "ccsds",
          "title": "Consultative Committee for Space Data Systems",
          "sourceUseClass": "standards-body-source",
          "riskLevel": "medium",
          "priority": "P2",
          "requiredDecisionCount": 6,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-983afbacdf83a228cfa1c6fc2db8b2e2d02a058bae244539d7326936b048a586"
        },
        {
          "id": "source-use-review-dymos",
          "sourceId": "dymos",
          "title": "Dymos",
          "sourceUseClass": "open-source-tool-or-code",
          "riskLevel": "medium",
          "priority": "P2",
          "requiredDecisionCount": 5,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-bbb82d5f622f7f7eb5a78f80d1e8b80fdb03389aad50e04f770de8b208121835"
        },
        {
          "id": "source-use-review-esa-psa",
          "sourceId": "esa-psa",
          "title": "ESA Planetary Science Archive",
          "sourceUseClass": "public-data-or-api-source",
          "riskLevel": "medium",
          "priority": "P2",
          "requiredDecisionCount": 5,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-290b747abe1952a3fa6bccb68dc75cdfca50f9c3cb2aed84fa46dea4255e8cf1"
        },
        {
          "id": "source-use-review-gmat",
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "sourceUseClass": "public-data-or-api-source",
          "riskLevel": "medium",
          "priority": "P2",
          "requiredDecisionCount": 5,
          "blockerCount": 6,
          "nextAction": "Capture terms/license evidence and reviewer approval before this source can support customer-facing deliverables.",
          "packetHash": "sha256-47fd3f4d01a3bf3328f0b2526ec78e45d9926230622c06be17e95b12b2beb6cf"
        }
      ]
    },
    "sourceUseClearanceDossier": {
      "mode": "deterministic-source-use-clearance-dossier",
      "sourceCount": 33,
      "blockedSourceCount": 33,
      "classCount": 5,
      "customerUseAllowed": false,
      "rawRedistributionAllowed": false,
      "dossierHash": "sha256-bd35dd0b228a9df062050b345e8b1763178982c752bac0b2e0ce6513a7596c18",
      "releaseImpact": "Customer-facing reports can cite source context internally, but commercial/customer use remains blocked until source-specific terms, citation, redistribution, provider-boundary, and named reviewer approvals are attached.",
      "classDossiers": [
        {
          "sourceUseClass": "commercial-public-source",
          "priority": "P0",
          "sourceCount": 2,
          "decisionState": "internal-research-only",
          "customerUseAllowed": false,
          "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
          "classDossierHash": "sha256-79efd7e40a02d5159a4551933b4823721a64f63380633cb76d92555ae526adb8"
        },
        {
          "sourceUseClass": "open-source-tool-or-code",
          "priority": "P1",
          "sourceCount": 7,
          "decisionState": "internal-research-only",
          "customerUseAllowed": false,
          "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
          "classDossierHash": "sha256-8003281e295e7bcc67cba2a9729994f94fd1bb9714fcf277aac96d54ddf13773"
        },
        {
          "sourceUseClass": "standards-body-source",
          "priority": "P1",
          "sourceCount": 4,
          "decisionState": "internal-research-only",
          "customerUseAllowed": false,
          "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
          "classDossierHash": "sha256-49d0e56137bda97da688e6f6925265ae5e686bc07ed84dd7c302d7a2ce677899"
        },
        {
          "sourceUseClass": "general-public-source",
          "priority": "P2",
          "sourceCount": 5,
          "decisionState": "internal-research-only",
          "customerUseAllowed": false,
          "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
          "classDossierHash": "sha256-3cb182bbab1c6ef00e766f12ad551ab3fd248d12352459a18324131ce9e81b40"
        },
        {
          "sourceUseClass": "public-data-or-api-source",
          "priority": "P2",
          "sourceCount": 15,
          "decisionState": "internal-research-only",
          "customerUseAllowed": false,
          "blockedUntil": "Customer-facing derived values, raw payloads, source tables, screenshots, standards text, provider marks, and commercial claims require source-specific review artifacts and named reviewer approval.",
          "classDossierHash": "sha256-115c95adf67664e2f449ac9f6ac36e171fb010e46419a15cf94356b55d1b8713"
        }
      ]
    },
    "sidecarWorkOrders": {
      "mode": "deterministic-sidecar-execution-work-orders",
      "workOrderCount": 5,
      "blockedWorkOrderCount": 5,
      "packetHash": "sha256-8e6bf30aec2a64bb3dfd0d7eaad748c8579454fb6d285b83b557a955c0ace4e4",
      "firstRunnableContract": "spice-gf-event-window-v1"
    },
    "sidecarValidation": {
      "mode": "deterministic-sidecar-validation-gate",
      "contractCount": 5,
      "validationCount": 5,
      "promotedCount": 0,
      "blockedCount": 5,
      "averageFieldCoveragePercent": 19,
      "promotionRule": "A sidecar artifact promotes only if it is runtime-generated, has all required fields, source ids match the contract, validation passed, and independent comparison passed where required."
    },
    "sidecarScaffoldRejections": {
      "mode": "deterministic-sidecar-scaffold-rejection-ledger",
      "scaffoldCount": 3,
      "rejectedScaffoldCount": 3,
      "unexpectedPromotionCount": 0,
      "scaffoldGatePassed": true,
      "ledgerHash": "sha256-9e715ab728e73d34a573d04dd6c813c311e0f1979e8bbbdd70f719123c4238e5",
      "rejectedContractIds": [
        "orekit-propagation-v1",
        "gmat-transfer-v1",
        "tudat-transfer-v1"
      ],
      "evidenceBoundary": "This ledger is a fail-closed scaffold audit. It cannot promote trajectory, transfer, logistics, or business claims."
    },
    "generatedArtifactCount": 7,
    "blockedArtifactCount": 7,
    "claimEvidenceLedger": {
      "mode": "deterministic-claim-evidence-ledger",
      "claimCount": 6,
      "verifiedClaimCount": 3,
      "blockedClaimCount": 3,
      "ledgerHash": "sha256-955a2d2ec1bb591b69b89b51865539cae43207d81051e6ba2e9bbfc696c37770",
      "gradeCounts": {
        "A-reviewable": 3,
        "D-blocked": 1,
        "C-partial": 2
      }
    },
    "verifiedClaims": [
      {
        "id": "claim-mercury-flux",
        "claim": "Mercury solar flux ranges roughly from 4.6x to 10.6x Earth, with mean near 6.7x.",
        "confidence": 0.92,
        "sources": [
          {
            "sourceId": "nasa-mercury",
            "title": "Mercury Facts",
            "trust": "primary",
            "url": "https://science.nasa.gov/mercury/facts/",
            "recordHash": "fnv1a32-78229f8d",
            "uncertaintyMode": "Factsheet summary caveats; not a substitute for mission data."
          }
        ]
      },
      {
        "id": "claim-de440-boundary",
        "claim": "DE440 should be treated as an operational ephemeris window, not a 50,000-year calendar.",
        "confidence": 0.9,
        "sources": [
          {
            "sourceId": "horizons-api",
            "title": "JPL Horizons API",
            "trust": "primary",
            "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html",
            "recordHash": "fnv1a32-9335c241",
            "uncertaintyMode": "API table tolerance plus downstream numeric tolerance."
          },
          {
            "sourceId": "spice-gf",
            "title": "SPICE Geometry Finder",
            "trust": "primary",
            "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
            "recordHash": "fnv1a32-97d74c96",
            "uncertaintyMode": "Kernel coverage plus geometric tolerance."
          }
        ]
      },
      {
        "id": "claim-dtn",
        "claim": "Disrupted interplanetary communications should use a store-and-forward planning model.",
        "confidence": 0.88,
        "sources": [
          {
            "sourceId": "nasa-dtn",
            "title": "Delay/Disruption Tolerant Networking",
            "trust": "primary",
            "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
            "recordHash": "fnv1a32-61e03fe6",
            "uncertaintyMode": "Conceptual architecture until mission-specific link data exists."
          }
        ]
      }
    ],
    "highImpactUnverifiedClaims": [
      {
        "id": "claim-spf-separation",
        "claim": "Vacuum anisotropic sheet forming and SPF/DB must be modeled as separate process cards.",
        "status": "Likely",
        "confidence": 0.78,
        "blocker": "Cannot be used as a commercialization proof until promoted."
      },
      {
        "id": "claim-mercury-core",
        "claim": "Mercury's iron core is strategically interesting but not an early accessible surface resource.",
        "status": "Likely",
        "confidence": 0.7,
        "blocker": "Cannot be used as a commercialization proof until promoted."
      }
    ],
    "modelArtifacts": [
      {
        "id": "artifact-horizons-geometry-v1",
        "name": "Horizons Earth/Mercury geometry snapshot",
        "claimState": "source-backed",
        "runtimeStatus": "deterministic-snapshot",
        "artifactHash": "fnv1a32-84000384",
        "nextAction": "Generate a live refresh artifact and preserve response hash."
      },
      {
        "id": "artifact-sbdb-cad-screen-v1",
        "name": "SBDB/CAD small-body candidate screen",
        "claimState": "source-backed-blocked",
        "runtimeStatus": "deterministic-snapshot",
        "artifactHash": "fnv1a32-38332261",
        "nextAction": "Attach candidate-specific taxonomy/spectra/PDS records before promotion."
      },
      {
        "id": "artifact-spice-gf-windows-v1",
        "name": "SPICE Geometry Finder event-window contract",
        "claimState": "adapter-contract",
        "runtimeStatus": "adapter-fixture",
        "artifactHash": "fnv1a32-6f7f670c",
        "nextAction": "Run SPICE with recorded kernels and store event-window hash."
      },
      {
        "id": "artifact-trajectory-sidecar-v1",
        "name": "Orekit/GMAT/Tudat trajectory validation sidecar",
        "claimState": "blocked",
        "runtimeStatus": "contract-ready-no-runtime-artifact",
        "artifactHash": "fnv1a32-0fa3828b",
        "nextAction": "Create offline sidecar job and compare at least one transfer window."
      },
      {
        "id": "artifact-space-environment-v1",
        "name": "Space environment and radiation evidence contract",
        "claimState": "hypothesis",
        "runtimeStatus": "design-contract",
        "artifactHash": "fnv1a32-2d8fc05a",
        "nextAction": "Add SPDF/CCMC/SWPC adapters for site-specific radiation and solar-weather assumptions."
      },
      {
        "id": "artifact-materials-process-v1",
        "name": "Materials/process physics module contract",
        "claimState": "hypothesis",
        "runtimeStatus": "design-contract",
        "artifactHash": "fnv1a32-3b863280",
        "nextAction": "Add NIST/Materials Project/Cantera/MOOSE/OpenFOAM artifact adapters."
      },
      {
        "id": "artifact-economics-uncertainty-v1",
        "name": "Economics and Monte Carlo frontier artifact",
        "claimState": "model-derived-unvalidated",
        "runtimeStatus": "deterministic-generated-monte-carlo",
        "artifactHash": "fnv1a32-83d7b008",
        "nextAction": "Attach dated launch-cost, capex, opex, and market-source records before promotion."
      }
    ]
  },
  "assumptions": [
    {
      "id": "assumption-snapshot-first",
      "title": "Browser consumes reviewed snapshots first",
      "state": "validated-product-rule",
      "uncertainty": "Low",
      "testGate": "All displayed science claims must resolve to local source records or reviewed artifacts.",
      "impact": {
        "assumptionId": "assumption-snapshot-first",
        "title": "Browser consumes reviewed snapshots first",
        "state": "validated-product-rule",
        "owner": "Science kernel",
        "uncertainty": "Low",
        "businessQuestion": "Would a live API/schema drift event change the scenario order without reviewed snapshots?",
        "affectedScenarioIds": [
          "hybrid",
          "moon-first",
          "asteroid-first",
          "mercury-orbit",
          "mercury-polar",
          "mars-first"
        ],
        "stressWeights": {
          "benefits": {
            "resourceConfidence": 1.06
          },
          "risks": {
            "feedstock": 1.12,
            "processMaturity": 1.08
          }
        },
        "sourceCoverage": {
          "sourceCount": 4,
          "missingSourceIds": [],
          "primarySourceCount": 4,
          "recordHashes": [
            "fnv1a32-9335c241",
            "fnv1a32-93c0fe91",
            "fnv1a32-ba0c45bb",
            "fnv1a32-97d74c96"
          ]
        },
        "scenarioImpacts": [
          {
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "baseRank": 2,
            "stressedRank": 2,
            "rankDelta": 0,
            "baseUtility": 65.69,
            "stressedUtility": 65.48,
            "utilityDelta": -0.21
          },
          {
            "scenarioId": "moon-first",
            "name": "Moon-first Bootstrap",
            "baseRank": 1,
            "stressedRank": 1,
            "rankDelta": 0,
            "baseUtility": 67.12,
            "stressedUtility": 67.01,
            "utilityDelta": -0.11
          },
          {
            "scenarioId": "asteroid-first",
            "name": "Asteroid Feedstock-first",
            "baseRank": 3,
            "stressedRank": 3,
            "rankDelta": 0,
            "baseUtility": 51.37,
            "stressedUtility": 50.91,
            "utilityDelta": -0.46
          },
          {
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "baseRank": 4,
            "stressedRank": 4,
            "rankDelta": 0,
            "baseUtility": 42.95,
            "stressedUtility": 42.91,
            "utilityDelta": -0.04
          },
          {
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "baseRank": 6,
            "stressedRank": 6,
            "rankDelta": 0,
            "baseUtility": 37.95,
            "stressedUtility": 38.12,
            "utilityDelta": 0.17
          },
          {
            "scenarioId": "mars-first",
            "name": "Mars-first Conventional Expansion",
            "baseRank": 5,
            "stressedRank": 5,
            "rankDelta": 0,
            "baseUtility": 40.78,
            "stressedUtility": 41.11,
            "utilityDelta": 0.33
          }
        ],
        "maxRankShift": 0,
        "maxUtilityDelta": 0.46,
        "stressedWinner": {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.01
        },
        "stressedUncertainty": {
          "iterations": 128,
          "seed": "assumption-snapshot-first-stress",
          "winner": "moon-first",
          "highestWinProbability": 70.31
        },
        "reviewGate": {
          "promotionAllowed": true,
          "state": "reviewable",
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
          "riskIfWrong": "Live API outages or schema changes could make the beta unreproducible."
        },
        "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8"
      }
    },
    {
      "id": "assumption-no-mercury-first",
      "title": "Mercury cannot be hardcoded as the winning scenario",
      "state": "validated-product-rule",
      "uncertainty": "Low",
      "testGate": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
      "impact": {
        "assumptionId": "assumption-no-mercury-first",
        "title": "Mercury cannot be hardcoded as the winning scenario",
        "state": "validated-product-rule",
        "owner": "Scenario engine",
        "uncertainty": "Low",
        "businessQuestion": "Can conservative transport, thermal, communications, and maturity assumptions make Moon-first win?",
        "affectedScenarioIds": [
          "hybrid",
          "moon-first",
          "mercury-orbit",
          "mercury-polar"
        ],
        "stressWeights": {
          "risks": {
            "transport": 1.22,
            "thermal": 1.18,
            "comms": 1.15,
            "processMaturity": 1.1
          }
        },
        "sourceCoverage": {
          "sourceCount": 3,
          "missingSourceIds": [],
          "primarySourceCount": 3,
          "recordHashes": [
            "fnv1a32-9335c241",
            "fnv1a32-7c477cc2",
            "fnv1a32-78229f8d"
          ]
        },
        "scenarioImpacts": [
          {
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "baseRank": 2,
            "stressedRank": 2,
            "rankDelta": 0,
            "baseUtility": 65.69,
            "stressedUtility": 65.85,
            "utilityDelta": 0.16
          },
          {
            "scenarioId": "moon-first",
            "name": "Moon-first Bootstrap",
            "baseRank": 1,
            "stressedRank": 1,
            "rankDelta": 0,
            "baseUtility": 67.12,
            "stressedUtility": 67.32,
            "utilityDelta": 0.2
          },
          {
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "baseRank": 4,
            "stressedRank": 4,
            "rankDelta": 0,
            "baseUtility": 42.95,
            "stressedUtility": 42.67,
            "utilityDelta": -0.28
          },
          {
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "baseRank": 6,
            "stressedRank": 6,
            "rankDelta": 0,
            "baseUtility": 37.95,
            "stressedUtility": 37.5,
            "utilityDelta": -0.45
          }
        ],
        "maxRankShift": 0,
        "maxUtilityDelta": 0.45,
        "stressedWinner": {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.32
        },
        "stressedUncertainty": {
          "iterations": 128,
          "seed": "assumption-no-mercury-first-stress",
          "winner": "moon-first",
          "highestWinProbability": 76.56
        },
        "reviewGate": {
          "promotionAllowed": true,
          "state": "reviewable",
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
          "riskIfWrong": "The product becomes advocacy rather than feasibility intelligence."
        },
        "impactHash": "sha256-af29cde19803c251fdb159311a364c052dcab8378ad33efccbe4fa6641075228"
      }
    },
    {
      "id": "assumption-resource-composition-unknown",
      "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
      "state": "blocked-until-source-backed",
      "uncertainty": "High",
      "testGate": "Taxonomy, spectra, or mission data required before promotion.",
      "impact": {
        "assumptionId": "assumption-resource-composition-unknown",
        "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
        "state": "blocked-until-source-backed",
        "owner": "Resource ledger",
        "uncertainty": "High",
        "businessQuestion": "Which resource-dependent scenarios degrade when composition evidence is held at unknown?",
        "affectedScenarioIds": [
          "hybrid",
          "asteroid-first",
          "mercury-orbit",
          "mercury-polar"
        ],
        "stressWeights": {
          "benefits": {
            "resourceConfidence": 1.25,
            "optionality": 0.92
          },
          "risks": {
            "feedstock": 1.35
          }
        },
        "sourceCoverage": {
          "sourceCount": 3,
          "missingSourceIds": [],
          "primarySourceCount": 3,
          "recordHashes": [
            "fnv1a32-7c477cc2",
            "fnv1a32-93c0fe91",
            "fnv1a32-ba0c45bb"
          ]
        },
        "scenarioImpacts": [
          {
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "baseRank": 2,
            "stressedRank": 2,
            "rankDelta": 0,
            "baseUtility": 65.69,
            "stressedUtility": 64.83,
            "utilityDelta": -0.86
          },
          {
            "scenarioId": "asteroid-first",
            "name": "Asteroid Feedstock-first",
            "baseRank": 3,
            "stressedRank": 3,
            "rankDelta": 0,
            "baseUtility": 51.37,
            "stressedUtility": 49.69,
            "utilityDelta": -1.68
          },
          {
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "baseRank": 4,
            "stressedRank": 4,
            "rankDelta": 0,
            "baseUtility": 42.95,
            "stressedUtility": 42.13,
            "utilityDelta": -0.82
          },
          {
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "baseRank": 6,
            "stressedRank": 6,
            "rankDelta": 0,
            "baseUtility": 37.95,
            "stressedUtility": 37.91,
            "utilityDelta": -0.04
          }
        ],
        "maxRankShift": 0,
        "maxUtilityDelta": 1.68,
        "stressedWinner": {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 66.89
        },
        "stressedUncertainty": {
          "iterations": 128,
          "seed": "assumption-resource-composition-unknown-stress",
          "winner": "moon-first",
          "highestWinProbability": 83.59
        },
        "reviewGate": {
          "promotionAllowed": false,
          "state": "blocked-for-business-proof",
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion.",
          "riskIfWrong": "Candidate feedstock rankings could imply unavailable or unmeasured materials."
        },
        "impactHash": "sha256-6d5911577e95f4f378f9c3b42381e039f24031c5391857cc77eb0fc0e1658c49"
      }
    },
    {
      "id": "assumption-social-signals-market-only",
      "title": "Forums and social platforms are market signals, not science evidence",
      "state": "approved-governance-rule",
      "uncertainty": "Low",
      "testGate": "Social-source records cannot promote claims without a primary-source bridge.",
      "impact": {
        "assumptionId": "assumption-social-signals-market-only",
        "title": "Forums and social platforms are market signals, not science evidence",
        "state": "approved-governance-rule",
        "owner": "Product strategy",
        "uncertainty": "Low",
        "businessQuestion": "Does market interest alter diligence priority without promoting a science or engineering claim?",
        "affectedScenarioIds": [
          "hybrid",
          "moon-first",
          "asteroid-first",
          "mercury-orbit",
          "mercury-polar",
          "mars-first"
        ],
        "stressWeights": {
          "benefits": {
            "optionality": 0.95
          },
          "risks": {
            "processMaturity": 1.04
          }
        },
        "sourceCoverage": {
          "sourceCount": 0,
          "missingSourceIds": [],
          "primarySourceCount": 0,
          "recordHashes": []
        },
        "scenarioImpacts": [
          {
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "baseRank": 2,
            "stressedRank": 2,
            "rankDelta": 0,
            "baseUtility": 65.69,
            "stressedUtility": 65.62,
            "utilityDelta": -0.07
          },
          {
            "scenarioId": "moon-first",
            "name": "Moon-first Bootstrap",
            "baseRank": 1,
            "stressedRank": 1,
            "rankDelta": 0,
            "baseUtility": 67.12,
            "stressedUtility": 67.04,
            "utilityDelta": -0.08
          },
          {
            "scenarioId": "asteroid-first",
            "name": "Asteroid Feedstock-first",
            "baseRank": 3,
            "stressedRank": 3,
            "rankDelta": 0,
            "baseUtility": 51.37,
            "stressedUtility": 51.28,
            "utilityDelta": -0.09
          },
          {
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "baseRank": 4,
            "stressedRank": 4,
            "rankDelta": 0,
            "baseUtility": 42.95,
            "stressedUtility": 42.98,
            "utilityDelta": 0.03
          },
          {
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "baseRank": 6,
            "stressedRank": 6,
            "rankDelta": 0,
            "baseUtility": 37.95,
            "stressedUtility": 37.98,
            "utilityDelta": 0.03
          },
          {
            "scenarioId": "mars-first",
            "name": "Mars-first Conventional Expansion",
            "baseRank": 5,
            "stressedRank": 5,
            "rankDelta": 0,
            "baseUtility": 40.78,
            "stressedUtility": 40.72,
            "utilityDelta": -0.06
          }
        ],
        "maxRankShift": 0,
        "maxUtilityDelta": 0.09,
        "stressedWinner": {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.04
        },
        "stressedUncertainty": {
          "iterations": 128,
          "seed": "assumption-social-signals-market-only-stress",
          "winner": "moon-first",
          "highestWinProbability": 68.75
        },
        "reviewGate": {
          "promotionAllowed": false,
          "state": "blocked-for-business-proof",
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
          "riskIfWrong": "Unverified narratives could contaminate verified claim states."
        },
        "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad"
      }
    },
    {
      "id": "assumption-launch-cost-ranges",
      "title": "Launch economics must use dated ranges and sensitivity bands",
      "state": "hypothesis",
      "uncertainty": "High",
      "testGate": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
      "impact": {
        "assumptionId": "assumption-launch-cost-ranges",
        "title": "Launch economics must use dated ranges and sensitivity bands",
        "state": "hypothesis",
        "owner": "Economics module",
        "uncertainty": "High",
        "businessQuestion": "Which scenario rankings are most sensitive to dated launch-cost and mass-to-site assumptions?",
        "affectedScenarioIds": [
          "hybrid",
          "moon-first",
          "asteroid-first",
          "mercury-orbit",
          "mercury-polar",
          "mars-first"
        ],
        "stressWeights": {
          "benefits": {
            "resourceConfidence": 1.08
          },
          "risks": {
            "transport": 1.35,
            "processMaturity": 1.08
          }
        },
        "sourceCoverage": {
          "sourceCount": 0,
          "missingSourceIds": [],
          "primarySourceCount": 0,
          "recordHashes": []
        },
        "scenarioImpacts": [
          {
            "scenarioId": "hybrid",
            "name": "Hybrid Moon -> Asteroid -> Mercury",
            "baseRank": 2,
            "stressedRank": 2,
            "rankDelta": 0,
            "baseUtility": 65.69,
            "stressedUtility": 65.62,
            "utilityDelta": -0.07
          },
          {
            "scenarioId": "moon-first",
            "name": "Moon-first Bootstrap",
            "baseRank": 1,
            "stressedRank": 1,
            "rankDelta": 0,
            "baseUtility": 67.12,
            "stressedUtility": 67.56,
            "utilityDelta": 0.44
          },
          {
            "scenarioId": "asteroid-first",
            "name": "Asteroid Feedstock-first",
            "baseRank": 3,
            "stressedRank": 3,
            "rankDelta": 0,
            "baseUtility": 51.37,
            "stressedUtility": 50.98,
            "utilityDelta": -0.39
          },
          {
            "scenarioId": "mercury-orbit",
            "name": "Mercury Orbit-first",
            "baseRank": 4,
            "stressedRank": 4,
            "rankDelta": 0,
            "baseUtility": 42.95,
            "stressedUtility": 42.28,
            "utilityDelta": -0.67
          },
          {
            "scenarioId": "mercury-polar",
            "name": "Mercury Polar Surface-first",
            "baseRank": 6,
            "stressedRank": 6,
            "rankDelta": 0,
            "baseUtility": 37.95,
            "stressedUtility": 37.32,
            "utilityDelta": -0.63
          },
          {
            "scenarioId": "mars-first",
            "name": "Mars-first Conventional Expansion",
            "baseRank": 5,
            "stressedRank": 5,
            "rankDelta": 0,
            "baseUtility": 40.78,
            "stressedUtility": 40.73,
            "utilityDelta": -0.05
          }
        ],
        "maxRankShift": 0,
        "maxUtilityDelta": 0.67,
        "stressedWinner": {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "utility": 67.56
        },
        "stressedUncertainty": {
          "iterations": 128,
          "seed": "assumption-launch-cost-ranges-stress",
          "winner": "moon-first",
          "highestWinProbability": 79.69
        },
        "reviewGate": {
          "promotionAllowed": false,
          "state": "blocked-for-business-proof",
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
          "riskIfWrong": "Scenario rankings could swing materially on stale or optimistic transport costs."
        },
        "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3"
      }
    }
  ],
  "notebook": null,
  "readiness": {
    "readyForPublicBeta": false,
    "blockers": [
      {
        "id": "science-math-credibility",
        "label": "Science/math credibility for beta",
        "currentScore": 96,
        "targetScore": 98,
        "blockers": [
          "Source Registry 2.0, assumption registry, scenario notebooks, generated model-artifact bundles, seeded scenario uncertainty analysis, generated economics frontier artifacts, business-case planning heuristics, one SPICE GF runtime artifact, and one OpenMDAO/Dymos beta optimization artifact are now local and tested, but Orekit/GMAT/Tudat runtime artifacts are not yet generated.",
          "Asteroid candidate CAD and SBDB source payloads are captured for the current worklist, but promotion remains blocked until MPC bridging, source-use review, human source-custody approval, and taxonomy/spectra/mission-archive composition evidence replace draft reviewer records."
        ]
      },
      {
        "id": "ui-review-readiness",
        "label": "UI review readiness",
        "currentScore": 90,
        "targetScore": 98,
        "blockers": [
          "The product shell and six primary pages have been rebuilt closer to the accepted mockup direction, but side-by-side screenshot fidelity still needs final page-by-page approval.",
          "Mobile no-overflow rendering and collapsible navigation are covered, but final typography/spacing approval against the reference set is still pending."
        ]
      },
      {
        "id": "deployment-readiness",
        "label": "Deployment readiness",
        "currentScore": 96,
        "targetScore": 98,
        "blockers": [
          "Cloudflare Pages and the custom hostname are live from a git baseline, and a CI/CD workflow is committed, but the repo still needs a remote/secrets-backed run before it counts as reproducible promotion.",
          "Cloudflare Access anonymous challenge and monitor service-token verification pass; owner browser review remains a human approval step."
        ]
      },
      {
        "id": "public-gated-live",
        "label": "Public/gated website live status",
        "currentScore": 96,
        "targetScore": 98,
        "blockers": [
          "The custom hostname is protected by Cloudflare Access; anonymous requests receive an Access challenge and the monitor service token reaches the app.",
          "A Worker Cron monitor and KV state store are live and healthy, but alert webhook/recovery proof still requires a real webhook or email relay."
        ]
      }
    ]
  },
  "governance": {
    "socialSignalRule": "Forum and social-platform records are market signals only and cannot verify science claims without a primary-source bridge.",
    "economicsRule": "Business-case cost outputs are planning heuristics until dated cost-source records are attached.",
    "sourceUseRule": "Source records are provenance only; legal/customer use requires terms capture, citation policy, redistribution review, and reviewer approval.",
    "promotionRule": "No model output can become a verified business or science claim without source records, units, uncertainty, reproducible query metadata, runtime evidence, and independent validation when applicable."
  },
  "reportHash": "fnv1a32-5b0df6f9"
}
;
